import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/auth-store';
import { getFxRates } from './api';

export function useFxRates() {
  const { status } = useAuth();
  return useQuery({
    queryKey: ['fx-rates'],
    queryFn: getFxRates,
    staleTime: 5 * 60_000,
    enabled: status === 'authed',
  });
}
